<template>
  <div class="mainCon solution-banner">
    <div class="swiper-container swiper-marketing ">
      <div class="swiper-wrapper"  >
        <div class="swiper-slide" v-for="(sli,index) in bannerList" :key="index">
          <div class="swiper-Title ">
            <!-- <p class="titleone">{{sli.textpic}}</p> -->
            <!-- <p class="titletwo">{{sli.textpict}}</p> -->
            <p v-if="sli.btntxt" class="titlebtn" v-text="sli.btntxt"  @click="changeanchorId(sli.id)"></p>
          </div>
          <img class="slidpic" :src="sli.slidpic" alt="" />
        </div>
      </div>
      <!-- 轮播分页器 -->
      <div class="swiper-pagination marketingpage">
        <div class="swbg"></div>
      </div>
    </div>
    <div class="mainDivWidth cooperation">
      <div class="coopmain">
        <p>佰付美</p>
        <span>营销合作平台</span>
      </div>
      <div class="coopban flexDiv">
        <div class="coopbody flexDiv">
          <div class="coopbanpic">
            <img class="scenario01" src="static/img/home/icon-1/scenario01.png" alt=""/>
          </div>
          <div class="coopbantxt">
            <p>五大场景</p>
            <span>涵盖汽车、生活和新能源三大类服务</span>
          </div>
        </div>
        <div class="coopbody flexDiv">
          <div class="coopbanpic">
            <img class="scenario02" src="static/img/home/icon-1/scenario02.png" alt=""/>
          </div>
          <div class="coopbantxt">
            <p>八类活动</p>
            <span>丰富多样化的搭配，新方式，心服务</span>
          </div>
        </div>
        <div class="coopbody flexDiv">
          <div class="coopbanpic">
            <img class="scenario03" src="static/img/home/icon-1/scenario03.png" alt=""/>
          </div>
          <div class="coopbantxt">
            <p>四种接入</p>
            <span>便捷好用，及时快速，服务精准</span>
          </div>
        </div>
      </div>
    </div>
    <div class="down mainDivWidth wow bounce animated " @click="changeanchorId('PlatformScene')">
      <img src="static/img/home/down.png" alt="">
    </div>
    <section class="mainDivWidth PlatformScene" id="PlatformScene">
      <h3 class="sectionTitle bgtext textCenter">便捷接入多种应用场景</h3>
      <div class="futitle sectionTitle">急速对接，精准触达目标用户群</div>
      <ul class="platform flexDiv">
        <li class="platcont smallRadius wow bounceIn animated"  v-for="( averl , cIndex) in averagList" :key="cIndex" :class="'sce' + cIndex"
         @click="averagClicka(averl.url,averl.types)">
          <div class="maskpla pointer">
            <img :src="averl.pic" alt="">
            <div class="plattxt smallRadius">
              <p v-text="averl.title"></p>
              <span v-text="averl.cont"></span>
            </div>
          </div> 
        </li>
      </ul>
    </section>
    <section class="discountsAct" id="discountsAct">
      <h3 class="sectionTitle countext textCenter ">定制化活动快速对接</h3>
      <div  class="futitle sectionTitle">深耕活动运营，有效提升产品活跃及流水，助您高效达成营销目标</div>
      <div class="discounts">
        <ul class="mainDivWidth discountban">
          <li class="discolist wow flipInY animated" v-for="(aol , index) in actListone" :key="index" @click="averagClick(aol.url)">
            <div class="discomask pointer">
              <img :src="aol.pic" alt="">
              <p v-text="aol.title"></p>
            </div> 
          </li>
        </ul>
        <ul class="mainDivWidth discountban borcont">
          <li class="discolist borbottom wow flipInY animated"  v-for="(atl , index) in actListtwo" :key="index" @click="averagClick(atl.url)">
            <div class="discomask pointer">
              <img :src="atl.pic" alt="">
              <p v-text="atl.title"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="mainDivWidth joinExplain" id="joinExplain">
      <h3 class="sectionTitle connet textCenter">专业成熟的能力开放</h3>
      <div class="futitle sectionTitle">为您提供便捷的开发对接服务</div>
      <ul class="instructions">
        <li class="instrucban wow rotateInDownLeft animated" v-for="( conl , cIndex) in connetList" :key="cIndex">
          <img :src="conl.pic" alt="">
          <div class="maskins pointer">
            <div class="instructxt">
              <p class="uptext" v-text="conl.title"></p>
              <span v-text="conl.cont"></span>
            </div>
            <button  @click="averagClick(conl.url)">查看详情</button>
          </div> 
        </li>
      </ul>
    </section>
   
  </div>
</template>

<script>
  import { WOW } from "wowjs";
  import Swiper from "swiper";
  import "swiper/css/swiper.min.css";
  import "swiper/js/swiper.min.js";
  export default {
    name: "homePage",
    data() {
      return {
        backTop: false,
        bannerList:[
        {
            textpic:"佰付美营销合作平台能力正式开放",
            textpict:"旨为企业提供更多优质场景及营销能力",
            slidpic:"static/img/home/homeslide/home-4.jpg"
          },
          {
            textpic:"多场景接入方案供企业选择",
            textpict:"加油、油卡充值、生活服务、数字娱乐等各类场景急速接入",
            btntxt:"立即对接",
            id:"PlatformScene",
            slidpic:"static/img/home/homeslide/home-1.jpg"
          },
          {
            textpic:"海量活动能力开放为企业提供定制化服务",
            btntxt:"了解更多",
            id:"discountsAct",
            textpict:"量身打造多种促活、促量方案",
            slidpic:"static/img/home/homeslide/home-3.jpg"
          },
          {
            textpic:"支付、营销、API对接能力开放",
            textpict:"提供一站式接入服务",
            btntxt:"立即对接",
            id:"joinExplain",
            slidpic:"static/img/home/homeslide/home-2.jpg"
          }
        ],
        actListone:[
          { 
            title: "立减活动", 
            pic: "static/img/home/icon-3/act01.png", 
            url: "/actStandBy" 
          },
          { 
            title: "后台发券", 
            pic: "static/img/home/icon-3/act02.png", 
            url: "/actAdminSend" 
          },
          { 
            title: "渠道发券", 
            pic: "static/img/home/icon-3/act03.png", 
            url: "/actChannelSend" 
          },
          {
            title: "购券活动", 
            pic: "static/img/home/icon-3/act04.png", 
            url: "/actBuyCoupon" 
          }
        ],
        actListtwo:[
          {
            title: "领券活动", 
            pic: "static/img/home/icon-3/act05.png", 
            url: "/actGetCoupon" 
          },
          {
            title: "抽奖活动", 
            pic: "static/img/home/icon-3/act06.png", 
            url: "/actLottery" 
          },
          {
            title: "券码兑换", 
            pic: " static/img/home/icon-3/act07.png", 
            url: "/actExchange" 
          },
          {
            title: "分享裂变", 
            pic: "static/img/home/icon-3/act08.png", 
            url: "/actShare" 
          }
        ],
        averagList:[
          {
            pic:"static/img/home/icon-2/oil.png",
            title:"去加油",
            cont:"可靠、实惠的线上加油服务",
            url:"/sceneFuel",
            types:"router"
          },
          {
            pic:"static/img/home/icon-2/car.png",
            title:"油卡充值",
            cont:"便捷、快捷的油卡充值服务",
            url:"/sceneOilPay",
            types:"router"
          },{
            pic:"static/img/home/icon-2/serve.png",
            title:"生活服务",
            cont:"多样、全面的线上生活服务",
            url:"/sceneLifeSer",
            types:"router"
          },
          // {
          //   pic:"static/img/home/icon-2/game.png",
          //   title:"数字娱乐",
          //   cont:"游戏分发、游戏推广服务",
          //   url:"/sceneDigital"
          // },
          // {
          //   pic:"static/img/home/icon-2/oilcar.png",
          //   title:"油证通",
          //   cont:"创新，高效营销模式",
          //   url:"/sceneOilCard"
          // },
          {
            pic:"static/img/home/icon-2/pay.png",
            title:"第三方支付",
            cont:"精益运营服务能力",
            url:"https://www.epaynfc.com/index.php/solution05-tripartite/",
            types:"link"
          },
          {
            pic:"static/img/home/icon-2/h2pic.png",
            title:"新能源",
            cont:"氢能运营、物流一体化服务",
            url:"https://www.epaynfc.com/index.php/solution06-hydroenergy/",
            types:"link"
          }
        ],
        connetList:[
          {
            pic:"static/img/home/pay/pay01.png",
            title:"H5支付",
            cont:"商户网站内支付新模式",
            url:"/dockH5pay"
          },
          {
            pic:"static/img/home/pay/pay02.png",
            title:"SDK支付",
            cont:"快速接入佰付美支付、营销系统",
            url:"/dockSdkpay"
          },
          {
            pic:"static/img/home/pay/pay03.png",
            title:"维纳宝发券接入",
            cont:"自有控制佰付美发券系统",
            url:"/dockWnbsendC"
          },
          {
            pic:"static/img/home/pay/pay04.png",
            title:"智慧加油API接入",
            cont:"快速接入佰付美线上加油服务",
            url:"/dockFuelAPI"
          }
        ]
      };
    },
    mounted() {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: false
      });
      wow.init();
      this.initswiper();
    },
    methods: {
      changeanchorId(id) {
        $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
        this.backTop = true;
        return false; // 返回false可以避免在原链接后加上#
      },
      //平台场景跳转详情
      averagClick(url){
        this.$router.push({"path": url })
      },
      //跳转链接
      averagClicka(url,type){
        if(type == 'router'){
          this.$router.push({"path": url })
        }else if(type == 'link'){
          window.location.href = url;
        }
      },
      initswiper() {
        var that = this;
        that.mySwiper = new Swiper(".swiper-marketing", {
          loop: true, // 循环模式选项
          autoplay: true, //自动播放
          touchRatio: 1,//触摸变慢
          // 分页器
          pagination: {
            el: ".marketingpage",
            clickable: true
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "../../assets/css/home";
</style>



// WEBPACK FOOTER //
// src/pages/homePage/home.vue